export default {
	adminPath: 'hf-admin-path',
}
